import React from "react";

const Sandslash = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-1.8 -0.15 309.15 270.65"
      {...rest}
    >
      <g>
        <path
          fill="#dcc200"
          d="M153.55 235.45 Q133.6 243.3 124.05 243.0 119.7 242.85 115.5 241.15 113.05 240.2 107.25 237.05 99.6 232.95 104.85 227.05 106.6 225.1 110.1 222.65 L114.75 219.45 160.1 213.25 Q167.2 217.6 166.2 223.85 165.15 230.9 153.55 235.45"
        />
        <path
          fill="#b49f00"
          d="M153.55 235.45 Q141.2 240.3 133.55 241.95 126.35 243.5 121.1 242.7 L120.25 240.7 Q119.35 239.1 119.6 238.75 123.45 232.65 122.35 228.7 121.0 224.0 112.65 220.9 L114.75 219.45 160.1 213.25 Q167.2 217.6 166.2 223.85 165.15 230.9 153.55 235.45"
        />
        <path
          fill="#eeeeef"
          d="M110.7 233.7 L99.65 244.75 86.3 247.8 Q86.95 244.9 93.6 237.7 99.8 230.95 102.65 229.25 104.7 228.0 107.15 230.0 L110.7 233.7"
        />
        <path
          fill="#c8c9ca"
          d="M95.25 241.9 Q104.95 235.8 110.25 233.25 L110.7 233.7 99.65 244.75 86.3 247.8 Q86.35 247.5 95.25 241.9"
        />
        <path
          fill="#eeeeef"
          d="M123.65 236.3 Q126.65 241.25 124.2 242.6 122.45 243.55 111.1 247.6 L94.3 253.55 Q97.65 245.75 105.75 238.1 113.05 231.2 116.05 231.2 120.6 231.2 123.65 236.3"
        />
        <path
          fill="#c8c9ca"
          d="M121.7 233.8 Q124.0 236.05 124.85 238.95 125.65 241.8 124.2 242.6 122.55 243.55 112.5 247.1 L96.3 252.8 Q104.85 242.55 121.7 233.8"
        />
        <path
          fill="#a35615"
          d="M39.25 93.25 Q29.35 91.0 20.1 80.9 11.95 71.95 10.5 64.85 L21.55 64.45 Q30.2 64.95 35.3 67.15 L52.15 87.5 39.25 93.25"
        />
        <path
          fill="#dcc200"
          d="M25.95 97.7 Q31.5 96.25 36.05 94.35 41.2 92.1 47.5 88.25 53.0 84.9 54.25 101.75 54.85 110.15 54.35 119.25 51.45 123.9 49.25 126.05 47.1 128.25 43.9 129.7 40.4 131.3 30.8 127.6 20.6 123.65 16.5 117.95 12.25 112.1 15.7 105.65 18.95 99.55 25.95 97.7"
        />
        <path
          fill="#b49f00"
          d="M54.25 101.95 Q54.85 110.35 54.35 119.25 51.45 123.9 49.25 126.05 47.1 128.25 43.9 129.7 L36.7 129.45 Q31.5 128.25 26.3 125.6 L35.4 121.0 Q40.25 118.5 42.75 115.65 49.45 108.15 47.75 88.1 53.05 85.25 54.25 101.95"
        />
        <path
          fill="#eeeeef"
          d="M24.9 115.5 Q28.3 117.45 19.95 135.35 15.8 144.3 10.95 152.85 L8.1 158.0 Q4.85 164.05 2.8 168.55 -0.95 149.4 5.05 130.9 8.15 121.25 13.9 112.4 L18.5 112.55 Q20.95 113.25 24.9 115.5"
        />
        <path
          fill="#c8c9ca"
          d="M24.9 115.5 Q28.3 117.45 19.95 135.35 15.8 144.3 10.95 152.85 L8.1 158.0 Q4.85 164.05 2.8 168.55 2.35 166.4 6.9 150.25 12.75 129.55 21.35 113.65 L24.9 115.5"
        />
        <path
          fill="#eeeeef"
          d="M26.3 108.8 Q31.25 106.95 36.5 112.9 41.5 118.6 42.3 125.8 35.0 132.25 24.4 149.25 20.9 154.85 10.95 172.45 7.75 152.2 15.35 129.55 18.1 121.25 21.6 115.0 24.7 109.4 26.3 108.8"
        />
        <path
          fill="#c8c9ca"
          d="M23.9 139.15 Q28.95 129.55 38.75 115.95 41.7 120.75 42.3 125.8 32.3 134.65 15.25 164.8 16.75 152.75 23.9 139.15"
        />
        <path
          fill="#dcc200"
          d="M137.4 222.6 Q117.5 224.95 105.9 213.55 L125.05 205.3 160.1 213.25 Q157.9 216.2 151.7 218.85 145.1 221.7 137.4 222.6"
        />
        <path
          fill="#b49f00"
          d="M137.4 222.6 Q117.5 224.95 105.9 213.55 L125.05 205.3 160.1 213.25 Q157.9 216.2 151.7 218.85 145.1 221.7 137.4 222.6"
        />
        <path
          fill="#dcc200"
          d="M284.5 226.95 Q264.9 234.55 238.1 231.5 L227.1 216.8 235.15 189.1 Q238.9 194.55 248.85 201.05 261.55 209.35 274.3 211.3 L292.05 212.35 301.75 211.6 Q303.95 211.35 304.35 212.85 304.8 214.45 302.05 216.5 292.3 223.85 284.5 226.95"
        />
        <path
          fill="#b49f00"
          d="M235.15 189.1 Q237.0 191.8 241.7 195.75 L249.55 212.6 Q253.4 221.0 256.8 221.55 267.95 223.4 279.15 222.55 290.9 221.6 299.9 217.85 L300.7 217.6 Q277.55 236.0 238.1 231.5 L227.1 216.8 235.15 189.1"
        />
        <path
          fill="#dcc200"
          d="M229.3 218.15 L233.7 222.15 Q238.45 227.05 240.05 231.5 241.15 234.55 234.9 242.25 227.95 250.8 219.5 253.7 210.35 256.85 201.0 255.65 191.85 254.55 185.9 249.8 180.75 245.75 185.3 237.4 188.75 231.1 194.05 226.95 L229.3 218.15"
        />
        <path
          fill="#b49f00"
          d="M240.05 231.5 Q241.15 234.55 234.9 242.25 227.95 250.8 219.5 253.7 L219.15 253.85 Q218.45 252.55 217.45 247.75 216.5 243.3 214.8 240.75 209.35 232.5 189.75 231.15 192.2 228.4 194.05 226.95 L229.3 218.15 233.7 222.15 Q238.45 227.05 240.05 231.5"
        />
        <path
          fill="#eeeeef"
          d="M186.55 241.0 Q192.6 241.2 196.45 247.25 198.0 249.7 198.05 251.8 198.05 254.0 196.3 254.7 191.3 256.7 180.45 260.3 167.7 264.5 163.35 265.15 166.3 259.25 174.6 250.3 183.35 240.85 186.55 241.0"
        />
        <path
          fill="#c8c9ca"
          d="M198.0 251.1 Q198.35 253.85 196.3 254.7 L185.3 258.65 170.25 263.45 Q178.15 259.0 183.45 255.4 190.35 250.7 195.35 245.7 197.6 248.45 198.0 251.1"
        />
        <path
          fill="#eeeeef"
          d="M209.4 241.3 Q213.5 239.75 218.45 243.95 223.1 247.9 223.1 251.45 219.6 255.15 207.75 260.85 195.75 266.6 186.2 269.05 187.5 262.7 197.1 252.2 205.7 242.75 209.4 241.3"
        />
        <path
          fill="#c8c9ca"
          d="M214.75 241.65 Q218.0 242.95 220.6 246.1 223.1 249.1 223.1 251.45 219.6 255.15 207.8 260.8 195.85 266.55 186.3 269.05 191.1 263.15 200.4 254.9 211.35 245.25 214.75 241.65"
        />
        <path
          fill="#a35615"
          d="M268.8 147.85 Q283.35 160.55 288.7 179.0 283.95 179.75 273.95 176.05 L264.85 172.15 233.65 140.85 249.5 135.9 Q259.7 139.9 268.8 147.85"
        />
        <path
          fill="#854507"
          d="M249.5 135.9 Q255.65 138.3 262.1 142.65 267.0 155.3 264.5 171.75 L233.65 140.85 249.5 135.9"
        />
        <path
          fill="#a35615"
          d="M236.8 140.15 Q246.9 145.8 256.0 157.25 269.35 174.15 271.4 194.95 261.35 193.9 250.25 188.4 238.4 182.5 232.55 174.75 L207.95 138.95 236.8 140.15"
        />
        <path
          fill="#854507"
          d="M207.95 138.95 L236.8 140.15 Q243.15 143.7 249.95 150.5 250.2 170.65 242.3 183.7 236.3 179.6 232.55 174.75 L207.95 138.95"
        />
        <path
          fill="#a35615"
          d="M247.45 79.85 Q238.05 84.75 229.95 87.9 L183.75 98.65 159.6 92.1 202.85 67.7 Q216.45 65.75 225.95 65.8 244.9 65.9 261.05 72.0 255.35 75.7 247.45 79.85"
        />
        <path
          fill="#854507"
          d="M218.55 66.0 L214.6 71.05 Q212.35 74.05 211.85 76.55 223.9 77.35 238.7 84.15 233.7 86.5 229.95 87.9 L183.75 98.65 159.6 92.1 202.85 67.7 218.55 66.0"
        />
        <path
          fill="#a35615"
          d="M192.2 92.05 Q198.9 89.05 205.75 87.95 224.8 84.85 250.15 95.45 248.65 97.7 239.3 103.8 229.5 110.2 225.35 111.1 L183.75 125.9 171.1 119.0 182.6 97.05 Q190.2 92.95 192.2 92.05"
        />
        <path
          fill="#854507"
          d="M182.6 97.05 L189.8 93.2 Q194.6 90.8 199.15 89.45 209.45 90.75 218.5 95.0 227.9 99.45 234.85 106.55 228.15 110.5 225.35 111.1 L183.75 125.9 171.1 119.0 182.6 97.05"
        />
        <path
          fill="#a35615"
          d="M183.25 124.5 Q200.7 107.5 231.1 111.7 243.2 113.35 254.1 118.15 264.3 122.65 269.45 128.05 260.65 134.8 246.45 138.2 229.3 142.3 211.35 139.15 L183.25 124.5"
        />
        <path
          fill="#854507"
          d="M219.85 124.8 Q228.5 131.45 235.3 140.0 223.8 141.3 211.35 139.15 L183.25 124.5 Q190.95 117.0 201.1 113.6 211.05 117.95 219.85 124.8"
        />
        <path
          fill="#dcc200"
          d="M170.25 118.25 Q176.4 122.9 186.9 126.8 198.45 131.1 205.8 135.9 214.25 141.45 222.55 153.65 233.3 169.5 234.2 185.5 235.2 204.15 230.1 214.75 224.15 227.2 209.7 229.25 196.35 231.15 183.9 224.0 176.65 219.8 168.9 211.6 126.6 220.25 104.1 185.85 92.9 168.7 88.95 145.35 L124.3 117.45 170.25 118.25"
        />
        <path
          fill="#b49f00"
          d="M170.25 118.25 Q176.4 122.9 186.9 126.8 198.45 131.1 205.8 135.9 214.25 141.45 222.55 153.65 233.3 169.5 234.2 185.5 235.2 203.85 230.3 214.4 224.55 226.75 210.6 229.1 221.2 222.15 223.6 210.1 225.9 198.6 220.2 185.55 214.4 172.25 202.05 161.4 188.75 149.75 170.8 143.7 154.8 138.3 132.4 123.15 131.1 122.25 126.85 124.3 L122.9 126.5 124.3 117.45 170.25 118.25"
        />
        <path
          fill="#f2d4b4"
          d="M164.6 169.25 Q164.6 174.45 163.7 189.25 163.75 203.2 168.8 211.85 124.4 220.3 102.75 185.8 93.05 170.3 88.95 145.35 L111.6 127.45 Q115.9 130.4 125.0 135.75 134.55 141.35 139.15 144.45 156.0 155.65 164.6 169.25"
        />
        <path
          fill="#f2d4b4"
          d="M165.5 169.45 Q165.7 169.75 165.1 170.4 164.5 171.05 164.3 170.75 157.5 159.95 145.9 150.7 138.2 144.55 124.85 136.7 L111.1 128.15 Q110.85 127.95 111.3 127.25 111.8 126.55 112.1 126.75 116.65 129.85 125.75 135.2 139.4 143.2 146.9 149.2 158.5 158.4 165.5 169.45"
        />
        <path
          fill="#d1b89d"
          d="M123.7 129.15 Q125.1 132.15 125.15 135.85 108.45 133.65 101.3 150.15 98.5 156.65 97.8 164.75 97.2 172.05 98.45 178.0 93.8 168.35 91.1 156.9 90.2 153.0 88.95 145.35 L101.6 135.25 Q114.9 125.15 118.25 125.1 121.8 125.05 123.7 129.15"
        />
        <path
          fill="#d1b89d"
          d="M102.1 184.7 Q106.4 189.8 114.8 194.3 123.3 198.85 132.5 200.85 155.15 205.85 163.8 193.3 164.5 204.4 168.8 211.85 144.0 216.55 126.0 207.6 111.6 200.4 102.1 184.7"
        />
        <path
          fill="#dcc200"
          d="M142.0 146.6 Q141.5 152.65 140.6 157.9 L119.65 141.75 121.25 132.95 Q122.5 126.95 125.5 125.15 129.35 122.85 134.1 124.2 139.05 125.65 141.15 130.35 143.0 134.45 142.0 146.6"
        />
        <path
          fill="#b49f00"
          d="M141.15 130.35 Q143.0 134.45 142.0 146.6 141.5 152.65 140.6 157.9 L131.85 151.15 Q137.25 140.4 135.45 124.7 139.45 126.45 141.15 130.35"
        />
        <path
          fill="#dcc200"
          d="M109.2 151.0 Q116.4 141.7 122.25 142.45 131.7 143.6 136.15 148.75 141.85 155.4 140.5 169.5 138.75 187.9 129.85 200.8 119.0 216.65 101.35 216.2 L75.25 180.3 Q76.2 175.35 82.4 170.6 88.2 166.15 96.45 163.3 99.85 162.15 103.35 158.35 L109.2 151.0"
        />
        <path
          fill="#b49f00"
          d="M135.05 147.6 Q142.0 154.15 140.5 169.5 138.75 187.9 129.85 200.8 119.0 216.65 101.35 216.2 L92.75 204.35 Q99.75 209.0 107.4 205.3 114.25 201.95 120.6 192.45 126.5 183.45 130.45 171.35 134.4 159.15 135.05 147.6"
        />
        <path
          fill="#eeeeef"
          d="M96.15 217.15 Q85.0 219.1 64.1 217.85 37.0 216.25 22.05 209.0 L45.85 206.7 101.35 199.85 Q104.8 200.2 107.4 201.1 110.7 202.25 110.5 203.8 110.05 206.7 106.75 210.7 102.3 216.1 96.15 217.15"
        />
        <path
          fill="#c8c9ca"
          d="M101.35 199.85 Q104.7 200.15 107.75 201.35 111.45 202.75 111.2 204.3 110.85 206.95 107.1 210.95 102.3 216.1 96.15 217.15 L70.35 218.15 Q48.55 217.45 33.15 213.1 49.8 213.5 60.95 211.6 76.0 209.0 86.0 201.75 L101.35 199.85"
        />
        <path
          fill="#eeeeef"
          d="M76.55 180.3 Q80.2 180.0 91.5 184.0 103.95 188.35 105.25 192.05 106.25 194.8 102.2 199.7 97.7 205.1 90.9 207.35 82.4 210.2 57.15 207.9 29.8 205.4 19.45 198.9 33.45 194.7 56.65 186.65 74.5 180.45 76.55 180.3"
        />
        <path
          fill="#c8c9ca"
          d="M101.25 200.75 Q96.9 205.4 90.9 207.35 83.05 210.0 59.6 208.1 34.3 206.1 22.25 200.4 47.9 204.1 67.15 203.3 92.55 202.2 105.4 193.4 105.0 196.75 101.25 200.75"
        />
        <path
          fill="#a35615"
          d="M69.05 38.95 L57.9 65.25 53.7 59.85 Q51.75 51.75 54.1 41.7 56.45 31.65 61.55 26.55 64.4 29.45 67.0 34.5 L69.05 38.95"
        />
        <path
          fill="#a35615"
          d="M179.7 62.15 L155.0 66.0 145.0 57.6 157.8 42.25 Q168.5 36.75 178.45 34.3 192.8 30.8 207.75 32.75 203.8 39.65 195.05 48.8 186.3 58.0 179.7 62.15"
        />
        <path
          fill="#854507"
          d="M184.0 48.7 Q189.1 48.05 195.4 48.45 186.5 57.85 179.7 62.15 L155.0 66.0 145.0 57.6 157.8 42.25 Q166.0 38.05 173.1 35.8 172.65 38.05 172.7 42.6 L172.55 51.35 Q178.95 49.35 184.0 48.7"
        />
        <path
          fill="#a35615"
          d="M167.6 89.9 L129.65 104.8 130.45 88.65 150.65 68.0 Q157.85 64.05 175.55 61.35 196.15 58.15 210.7 60.85 206.2 66.95 193.3 76.1 178.85 86.3 167.6 89.9"
        />
        <path
          fill="#854507"
          d="M170.55 62.2 Q169.95 67.0 168.05 72.05 166.6 76.0 163.7 81.65 171.25 82.4 179.9 84.45 173.25 88.1 167.6 89.9 L129.65 104.8 130.45 88.65 150.65 68.0 Q153.15 66.65 158.45 65.1 163.85 63.5 170.55 62.2"
        />
        <path
          fill="#a35615"
          d="M169.75 119.95 Q146.75 130.7 124.2 121.55 L127.8 102.6 Q130.55 99.35 135.9 96.4 142.45 92.85 150.35 91.45 171.65 87.6 195.0 100.35 186.0 112.4 169.75 119.95"
        />
        <path
          fill="#854507"
          d="M138.4 95.05 Q147.95 90.35 159.65 90.5 159.75 102.0 159.25 107.6 158.4 117.25 155.4 124.65 139.5 127.75 124.2 121.55 L127.8 102.6 Q132.4 98.0 138.4 95.05"
        />
        <path
          fill="#dcc200"
          d="M50.55 85.8 Q41.0 81.6 36.85 70.6 32.25 58.35 34.85 38.9 41.1 41.9 46.95 47.7 55.45 56.2 58.4 67.0 L58.85 70.7 Q59.25 75.05 58.95 78.35 58.0 89.1 50.55 85.8"
        />
        <path
          fill="#b49f00"
          d="M58.4 67.0 L58.85 70.7 Q59.25 75.05 58.95 78.35 58.0 89.1 50.55 85.8 L49.6 85.35 Q51.95 73.95 52.1 66.9 52.3 56.7 48.55 49.4 55.8 57.25 58.4 67.0"
        />
        <path
          fill="#dcc200"
          d="M129.2 39.95 Q131.0 63.15 130.6 74.0 129.7 97.15 129.05 103.95 127.15 122.75 122.45 127.1 118.45 130.75 107.5 135.05 96.6 139.3 94.65 141.1 L87.5 147.55 Q82.85 150.85 77.2 150.85 72.45 150.85 70.2 149.85 66.9 148.35 62.65 143.1 60.6 140.6 59.5 134.05 58.1 125.95 57.0 123.15 52.8 119.6 50.75 113.9 48.55 107.75 50.0 102.1 47.4 100.5 48.1 95.0 48.7 90.2 51.45 84.15 L53.1 81.1 Q54.05 79.35 54.5 77.45 58.65 61.6 65.65 46.85 76.2 24.8 88.45 17.55 89.05 22.6 91.0 33.35 92.85 43.75 93.5 46.2 98.75 38.45 107.6 29.0 118.65 17.2 126.35 13.1 127.55 18.4 129.2 39.95"
        />
        <path
          fill="#b49f00"
          d="M130.1 53.25 Q130.85 66.85 130.6 74.0 129.7 97.15 129.05 103.95 127.15 122.75 122.45 127.1 118.45 130.75 107.5 135.05 96.6 139.3 94.65 141.1 93.6 142.1 92.05 141.1 90.55 140.15 89.7 138.15 87.5 132.8 92.55 130.05 98.4 127.0 101.55 124.45 108.7 118.75 113.95 109.6 129.55 82.75 128.3 29.25 129.45 41.35 130.1 53.25"
        />
        <path
          fill="#f2d4b4"
          d="M55.5 121.7 L59.25 123.35 Q61.45 124.35 61.45 124.75 62.45 132.7 63.05 135.4 64.1 140.1 65.85 141.45 68.1 143.3 72.0 143.6 76.55 143.9 80.25 141.45 81.15 140.85 84.4 134.7 88.2 127.35 92.55 122.2 105.65 106.8 109.25 103.4 120.2 93.1 129.85 92.55 128.35 121.65 122.45 127.1 118.45 130.75 107.5 135.05 96.6 139.3 94.65 141.1 84.25 150.85 77.2 150.85 72.45 150.85 70.2 149.85 66.9 148.35 62.65 143.1 60.6 140.6 59.5 134.05 58.1 125.95 57.0 123.15 L55.5 121.7"
        />
        <path
          fill="#a35615"
          d="M93.2 48.0 L87.65 30.5 Q89.25 23.9 97.75 15.05 106.9 5.55 116.35 2.1 117.3 8.85 116.85 15.45 116.45 21.55 115.4 22.35 L93.2 48.0"
        />
        <path
          fill="#854507"
          d="M87.65 30.5 Q88.45 27.2 91.4 22.8 94.4 18.35 98.75 14.05 105.05 24.75 107.4 31.55 L93.2 48.0 87.65 30.5"
        />
        <path
          fill="#a35615"
          d="M142.7 20.75 Q155.2 11.8 165.65 8.95 166.75 17.5 161.6 31.4 156.4 45.35 149.55 51.9 L130.8 60.25 128.75 34.75 Q130.55 29.4 142.7 20.75"
        />
        <path
          fill="#854507"
          d="M128.75 34.75 Q129.65 32.05 133.95 27.9 138.15 23.85 144.1 19.75 150.4 32.55 153.95 46.6 151.85 49.7 149.55 51.9 L130.8 60.25 128.75 34.75"
        />
        <path
          fill="#a35615"
          d="M126.65 12.5 Q127.8 17.7 129.35 39.65 131.0 63.0 130.6 73.95 112.15 68.8 90.9 85.35 80.25 93.6 73.3 102.9 70.9 93.7 67.55 85.25 60.8 68.3 56.0 72.1 60.1 57.6 68.25 42.1 78.8 21.95 88.45 17.55 89.05 22.6 90.95 33.1 92.75 43.25 93.4 45.7 102.35 34.8 107.7 29.05 119.3 16.45 126.65 12.5"
        />
        <path
          fill="#a35615"
          d="M130.8 73.15 Q131.15 73.25 130.9 74.05 130.7 74.9 130.35 74.8 114.65 70.4 96.35 82.55 85.3 89.9 75.75 101.25 73.5 103.9 73.05 103.8 72.6 103.7 71.8 100.8 67.95 86.7 63.75 78.8 59.25 70.45 56.15 72.85 55.45 71.75 56.7 71.05 57.9 70.4 58.95 70.75 63.15 72.2 68.1 84.25 71.15 91.65 73.7 101.0 83.05 89.55 94.4 81.8 113.9 68.4 130.8 73.15"
        />
        <path
          fill="#854507"
          d="M126.65 12.5 Q127.8 17.7 129.35 39.65 131.0 63.0 130.6 73.95 125.1 72.4 118.9 72.9 121.4 61.5 124.1 35.6 126.5 12.6 126.65 12.5"
        />
        <path
          fill="#f2d4b4"
          d="M130.6 91.75 L130.5 93.2 Q119.75 93.35 104.2 109.8 91.2 123.5 84.25 137.15 82.2 141.2 80.7 142.2 76.85 144.8 71.85 144.2 67.7 143.75 65.15 141.7 63.3 140.25 62.4 136.55 61.65 133.4 60.45 123.7 L62.5 124.7 63.5 135.25 Q64.0 139.45 65.55 140.65 67.6 142.3 71.5 142.8 76.25 143.35 79.75 141.05 L81.5 139.15 83.55 135.9 Q90.2 122.9 102.5 109.6 118.35 92.5 130.6 91.75"
        />
        <path
          fill="#0d131a"
          d="M50.0 102.1 Q52.6 100.9 57.5 108.65 62.65 116.8 62.05 124.0 61.05 124.15 59.0 123.25 56.4 122.1 54.3 120.0 48.3 113.75 50.0 102.1"
        />
        <path
          fill="#0d131a"
          d="M90.7 121.75 Q89.4 115.7 93.75 107.75 99.6 96.95 113.15 93.1 114.05 104.5 111.1 111.85 106.05 124.45 90.7 121.75"
        />
        <path
          fill="#dcc200"
          d="M86.7 95.15 Q84.55 98.95 79.7 103.4 73.45 109.25 72.4 109.2 71.1 109.15 67.95 102.35 62.35 90.2 64.7 77.45 67.5 62.5 80.9 50.45 83.85 54.35 86.7 64.35 89.95 75.9 89.45 85.1 89.15 90.75 86.7 95.15"
        />
        <path
          fill="#b49f00"
          d="M86.9 67.35 Q89.5 75.45 89.85 80.85 90.7 93.2 79.7 103.4 L78.15 104.25 Q77.3 104.45 77.3 104.0 80.2 100.55 82.05 92.35 85.8 75.95 80.85 50.45 L80.9 50.45 Q85.8 63.8 86.9 67.35"
        />
        <path
          fill="#dcc200"
          d="M114.3 80.2 Q118.4 68.5 129.8 60.55 145.0 49.95 167.9 51.25 159.5 66.1 148.25 76.8 134.75 89.65 123.55 89.45 L117.35 89.25 Q111.7 87.6 114.3 80.2"
        />
        <path
          fill="#b49f00"
          d="M148.25 76.8 Q134.75 89.65 123.55 89.45 L121.8 89.65 Q133.7 83.7 144.05 73.05 155.05 61.7 157.75 51.35 162.7 50.95 167.9 51.25 159.5 66.1 148.25 76.8"
        />
        <path
          fill="#ffffff"
          d="M98.85 101.55 Q101.25 103.6 101.5 107.3 101.75 110.65 100.3 113.65 98.75 116.7 96.4 117.3 93.75 117.95 91.2 114.9 91.5 112.5 92.65 109.6 94.85 103.85 98.85 101.55"
        />
        <path
          fill="#ffffff"
          d="M54.75 106.6 Q56.65 107.8 58.7 113.35 L60.4 118.65 Q58.1 120.9 55.55 116.2 52.95 111.4 54.75 106.6"
        />
        <path
          fill="#d1b89d"
          d="M120.0 96.65 L120.6 94.8 Q125.75 92.15 130.15 91.8 L130.05 93.25 Q128.35 121.65 122.45 127.1 118.45 130.75 107.5 135.05 96.6 139.3 94.65 141.1 L87.85 147.3 Q83.4 150.55 78.25 150.8 79.4 147.0 80.0 145.7 81.65 142.05 84.2 140.05 92.55 134.75 99.8 127.85 113.7 114.55 120.0 96.65"
        />
        <path
          fill="#0d131a"
          d="M115.25 220.15 L111.25 223.1 Q106.9 226.5 104.95 228.85 L102.1 229.1 Q103.15 226.65 107.5 223.5 L114.0 219.25 115.25 220.15"
        />
        <path
          fill="#0d131a"
          d="M154.4 236.55 Q133.95 244.6 123.05 244.25 124.45 243.5 124.7 242.1 129.5 242.2 136.1 240.45 142.9 238.7 153.25 234.6 158.85 232.45 161.95 229.5 165.1 226.55 165.4 223.25 165.65 220.7 164.1 218.25 162.6 215.8 159.65 214.0 L160.85 212.7 Q164.25 214.75 166.25 218.1 168.3 221.4 168.0 224.45 167.7 228.15 164.05 231.2 160.75 234.05 154.4 236.55"
        />
        <path
          fill="#0d131a"
          d="M84.6 247.2 Q88.0 241.15 93.4 235.65 98.2 230.8 102.25 228.6 104.45 227.4 106.9 228.95 108.25 229.9 111.35 233.2 L110.2 234.2 Q107.35 231.15 106.1 230.3 104.5 229.2 103.05 229.9 99.65 231.6 94.4 237.45 89.6 242.85 87.55 246.75 L99.85 243.95 98.4 246.3 Q91.55 247.6 88.05 248.65 84.3 249.75 83.85 249.5 83.45 249.25 84.6 247.2"
        />
        <path
          fill="#0d131a"
          d="M123.8 241.95 Q124.35 241.65 124.35 240.65 L124.15 239.35 Q123.45 236.7 121.3 234.5 118.85 231.95 116.05 231.95 113.65 231.95 107.0 238.0 99.45 244.9 95.8 252.2 L105.7 248.65 Q121.75 243.1 123.8 241.95 M122.7 233.55 Q125.4 236.2 126.15 239.15 126.55 240.65 126.1 242.1 125.7 243.45 124.75 243.95 123.35 244.75 111.3 248.95 L95.55 254.2 92.35 254.8 Q91.95 254.6 93.05 252.55 97.6 244.1 104.7 237.25 111.85 230.4 116.05 230.45 119.55 230.5 122.7 233.55"
        />
        <path
          fill="#0d131a"
          d="M22.2 63.45 Q30.3 64.1 35.65 66.45 L35.7 68.1 Q31.1 66.1 23.15 65.4 16.55 64.8 12.55 65.3 L11.8 65.45 Q11.6 65.65 11.9 66.5 14.45 74.1 21.7 81.65 30.1 90.4 39.4 92.5 L37.7 93.55 Q27.7 91.1 19.95 83.15 12.85 75.95 9.35 66.1 8.85 64.6 9.05 64.15 9.3 63.75 10.75 63.55 15.6 62.9 22.2 63.45"
        />
        <path
          fill="#0d131a"
          d="M25.75 96.85 Q31.6 95.05 39.1 91.75 47.75 87.95 49.75 85.85 51.65 83.95 50.8 86.2 L49.55 88.8 Q46.9 90.65 39.2 93.9 31.25 97.25 26.2 98.55 22.6 99.5 19.8 101.95 16.95 104.4 15.8 107.65 15.1 109.5 15.4 111.75 L13.4 113.35 Q12.85 111.8 12.8 110.6 12.75 109.35 13.2 107.6 14.15 104.0 16.8 101.55 19.85 98.7 25.75 96.85"
        />
        <path
          fill="#0d131a"
          d="M53.6 118.8 L54.45 120.75 Q51.25 125.75 49.45 127.65 47.25 129.85 43.95 131.05 L37.55 130.85 39.2 129.05 43.55 128.9 Q46.6 127.45 48.65 125.4 50.75 123.3 53.6 118.8"
        />
        <path
          fill="#0d131a"
          d="M14.1 110.85 L16.95 111.2 Q20.25 111.85 22.35 113.25 L21.75 114.65 Q19.9 113.85 18.35 113.4 15.45 112.5 14.35 113.1 2.1 132.3 2.1 153.85 2.1 159.15 3.2 165.9 5.2 161.75 7.9 156.75 L10.3 152.5 10.35 155.7 7.5 161.4 3.5 168.85 Q2.75 170.0 2.4 169.65 2.1 169.35 1.7 167.45 -1.8 151.85 1.8 136.05 5.3 120.6 14.1 110.85"
        />
        <path
          fill="#0d131a"
          d="M32.85 111.0 Q29.0 108.6 26.55 109.55 25.25 110.05 22.75 114.4 20.0 119.15 17.5 125.8 10.85 143.5 10.85 160.75 10.85 165.35 11.45 170.0 L12.15 168.75 Q20.3 154.2 25.4 146.2 34.7 131.6 41.45 125.5 40.9 121.0 38.55 117.05 36.15 113.0 32.85 111.0 M43.05 125.7 Q43.15 126.8 42.3 127.05 35.85 132.8 24.1 152.0 18.15 161.65 11.6 173.6 10.05 176.5 9.45 173.1 6.25 153.25 13.9 129.5 16.8 120.55 20.35 114.05 23.65 108.0 25.5 107.55 L29.05 107.65 Q31.6 108.1 33.3 109.15 37.25 111.55 39.75 115.5 42.6 120.0 43.05 125.7"
        />
        <path
          fill="#0d131a"
          d="M159.4 212.75 L161.8 212.8 Q158.65 217.0 152.3 220.1 145.25 223.55 136.75 224.2 128.25 224.9 120.8 223.1 112.65 221.1 107.55 216.55 L109.95 215.8 Q120.0 223.15 135.3 221.9 143.4 221.25 150.6 218.4 157.2 215.7 159.4 212.75"
        />
        <path
          fill="#0d131a"
          d="M234.45 189.6 L234.55 186.1 Q238.5 191.9 248.8 199.15 262.1 208.55 274.45 210.4 L290.35 211.65 301.65 210.75 Q306.8 209.75 307.1 211.35 307.35 212.9 303.15 217.3 294.2 226.55 276.9 231.0 258.8 235.65 240.25 232.5 L239.95 231.45 239.55 230.35 Q256.9 232.8 274.6 228.6 291.35 224.6 300.4 216.7 302.75 214.65 303.1 213.4 303.4 212.2 301.7 212.65 L291.3 213.4 273.55 212.45 Q260.85 210.5 248.15 201.95 238.35 195.3 234.45 189.6"
        />
        <path
          fill="#0d131a"
          d="M229.8 217.45 L233.55 220.3 Q237.55 223.8 240.25 228.2 242.5 231.85 240.25 236.45 237.8 241.6 233.0 246.65 226.9 252.95 220.2 255.25 L218.7 255.7 222.2 251.6 Q227.6 248.95 232.25 243.9 236.0 239.75 237.95 235.75 238.75 234.05 238.7 232.75 238.6 231.0 237.2 228.4 236.0 226.05 232.3 222.25 L228.75 218.85 229.8 217.45"
        />
        <path
          fill="#0d131a"
          d="M184.35 242.25 Q182.75 242.55 181.4 244.15 180.55 240.05 185.2 234.25 188.3 230.4 192.45 227.15 L194.6 227.65 Q191.65 230.0 188.7 233.85 185.15 238.5 184.35 242.25"
        />
        <path
          fill="#0d131a"
          d="M186.55 240.2 Q190.5 240.4 194.2 243.1 197.55 245.55 199.0 248.7 L197.15 250.7 Q196.45 247.65 193.55 244.95 190.3 241.9 186.5 241.75 184.0 241.65 173.8 252.65 163.6 263.6 164.8 264.1 165.75 264.45 177.75 260.5 187.75 257.15 194.45 254.6 L193.1 256.35 191.7 258.1 Q186.25 260.35 176.7 263.05 L165.05 266.0 161.45 266.1 Q161.2 265.7 162.65 262.9 166.0 256.35 174.3 248.3 182.8 240.05 186.55 240.2"
        />
        <path
          fill="#0d131a"
          d="M220.55 247.3 Q218.9 245.1 216.65 243.55 212.7 240.85 209.65 242.05 205.45 243.95 196.65 254.05 187.7 264.3 187.35 267.95 187.25 268.8 203.0 261.65 219.15 254.3 222.3 251.15 222.15 249.45 220.55 247.3 M208.25 240.9 Q210.15 240.1 212.7 240.45 215.35 240.8 217.55 242.25 220.3 244.15 222.25 246.8 224.3 249.5 224.3 251.5 L224.05 252.6 Q220.75 256.15 207.7 262.15 195.85 267.6 187.8 269.95 L184.45 270.5 Q183.9 270.25 184.75 268.15 188.65 258.6 197.2 249.7 204.15 242.5 208.25 240.9"
        />
        <path
          fill="#0d131a"
          d="M249.25 136.6 L251.8 135.95 Q264.7 141.0 275.15 152.5 285.25 163.6 290.0 177.3 290.85 179.9 290.2 180.55 L286.25 180.8 Q283.05 180.3 275.45 177.55 267.9 174.75 265.3 173.1 L264.0 170.8 Q286.4 178.9 287.4 178.0 287.9 177.55 285.55 172.75 282.8 167.1 278.5 161.2 265.85 143.8 249.25 136.6"
        />
        <path
          fill="#0d131a"
          d="M235.0 139.9 L237.15 139.45 Q247.15 145.05 257.4 157.65 271.7 175.15 272.6 193.2 272.75 196.1 272.1 196.6 L269.75 196.55 Q260.1 194.95 250.25 190.1 238.55 184.35 232.7 176.6 L232.4 173.95 Q237.6 180.8 253.9 188.35 259.95 191.2 265.05 192.9 269.9 194.55 270.4 194.05 271.0 193.4 269.5 187.8 267.65 181.15 264.1 173.85 253.6 152.4 235.0 139.9"
        />
        <path
          fill="#0d131a"
          d="M260.45 70.55 Q262.4 71.35 262.45 71.75 262.6 72.3 260.65 73.8 258.3 75.65 249.25 80.15 239.2 85.15 230.2 88.65 L226.9 88.05 Q235.35 84.75 245.8 79.55 255.55 74.75 257.95 72.85 259.0 72.1 257.6 71.65 250.65 69.2 236.35 67.65 217.0 65.5 202.95 68.45 L205.35 66.1 Q214.15 63.85 228.05 64.25 246.4 64.75 260.45 70.55"
        />
        <path
          fill="#0d131a"
          d="M249.55 93.4 Q251.5 94.2 251.75 95.1 252.1 96.0 250.65 97.25 245.6 101.65 238.55 105.85 231.15 110.3 226.7 111.3 L223.4 111.05 Q226.7 110.35 236.7 104.05 245.15 98.7 247.4 96.75 L248.2 95.9 247.4 95.15 Q244.55 93.65 238.4 92.05 230.75 90.05 222.85 89.35 200.55 87.3 186.75 96.25 L184.1 95.35 Q197.15 88.1 207.6 86.5 226.45 83.65 249.55 93.4"
        />
        <path
          fill="#0d131a"
          d="M211.2 139.9 L209.3 138.45 Q227.65 141.6 247.05 136.65 259.1 133.55 265.05 129.9 L267.5 127.95 Q267.95 127.2 267.05 126.65 249.05 115.35 227.85 112.65 200.15 109.1 183.8 125.05 L181.1 124.55 Q200.9 106.85 229.2 109.95 252.25 112.5 269.5 125.85 270.95 127.0 271.0 127.65 271.1 128.35 269.7 129.4 260.9 136.0 246.1 139.6 227.55 144.1 211.2 139.9"
        />
        <path
          fill="#0d131a"
          d="M88.5 146.6 L90.0 145.35 Q91.3 153.9 94.55 163.45 93.95 163.5 91.75 164.55 90.35 160.0 89.5 154.5 L88.5 146.6"
        />
        <path
          fill="#0d131a"
          d="M195.45 131.35 Q192.3 129.9 186.95 127.95 L178.85 124.8 Q174.3 122.8 170.2 119.7 L173.0 118.45 Q177.0 121.45 180.55 123.05 L187.7 125.7 Q194.65 128.35 196.95 129.35 202.75 131.95 207.5 135.2 217.7 142.15 225.6 154.4 235.4 169.6 236.4 186.25 237.55 205.6 231.1 216.9 224.35 228.6 209.85 230.7 191.6 233.3 175.75 219.9 L172.5 216.95 168.4 212.75 Q142.75 217.75 124.25 207.55 L125.85 205.45 Q143.45 215.35 167.1 210.9 164.1 206.25 162.85 199.8 161.9 194.85 161.9 188.15 161.9 183.55 162.85 176.3 163.7 170.1 164.55 166.5 165.25 163.65 166.15 162.0 167.05 160.45 167.15 161.7 167.25 162.65 166.75 165.65 L165.65 172.8 Q161.95 202.3 172.4 213.45 179.45 220.95 188.15 224.9 198.7 229.75 209.55 228.25 222.55 226.4 228.4 215.8 234.25 205.25 233.15 185.55 232.3 169.8 221.8 154.25 213.65 142.25 205.25 136.75 200.4 133.6 195.45 131.35"
        />
        <path
          fill="#0d131a"
          d="M125.05 124.4 Q129.7 121.75 135.95 124.25 141.45 126.45 142.6 129.4 145.0 135.45 143.45 150.2 142.65 157.65 141.3 164.4 L139.75 157.75 Q140.6 152.45 141.1 146.5 142.1 134.55 140.35 130.7 138.5 126.5 134.05 125.1 L129.8 124.65 Q127.7 124.85 125.95 125.9 124.0 127.1 122.15 134.2 121.25 137.85 120.45 142.05 L117.35 143.15 Q118.1 138.7 119.3 134.55 121.65 126.35 125.05 124.4"
        />
        <path
          fill="#0d131a"
          d="M76.25 180.5 L74.25 180.1 Q73.5 169.95 94.75 162.65 97.8 161.6 101.4 158.4 104.4 155.7 107.2 152.0 111.9 145.85 113.9 144.0 118.05 140.3 122.3 140.8 131.45 141.95 136.2 147.05 143.0 154.3 141.55 169.6 139.5 190.9 129.8 204.1 117.95 220.2 98.4 217.1 L101.4 215.15 Q119.15 215.6 129.8 199.05 137.9 186.4 139.5 169.4 140.85 155.35 135.0 149.0 130.8 144.5 122.1 143.45 118.5 143.0 115.0 146.1 112.85 147.95 108.85 153.2 105.3 157.85 103.35 159.8 100.1 163.15 96.8 164.3 88.4 167.15 82.75 171.65 77.1 176.1 76.25 180.5"
        />
        <path
          fill="#0d131a"
          d="M109.75 203.65 Q108.95 202.65 106.35 201.75 103.8 200.9 101.3 200.65 L102.55 199.15 106.55 199.75 Q110.25 200.6 111.85 202.25 114.05 204.5 109.45 210.45 104.55 216.8 97.65 218.0 84.55 220.25 68.9 219.8 43.1 219.05 21.95 210.45 18.45 209.05 19.1 208.15 19.65 207.35 23.15 207.15 L45.8 205.95 47.3 206.55 Q48.85 207.15 49.05 207.4 L34.3 208.65 25.2 209.45 Q37.4 215.3 61.25 216.9 82.85 218.35 96.6 215.7 102.55 214.55 106.95 209.55 110.85 205.1 109.75 203.65"
        />
        <path
          fill="#0d131a"
          d="M19.55 197.2 Q41.55 191.1 75.8 179.2 81.1 179.55 88.65 181.8 98.1 184.65 105.35 189.15 108.9 191.4 106.55 196.3 104.85 199.75 101.55 202.95 97.45 206.9 92.4 208.55 83.1 211.7 64.5 210.5 42.4 209.05 20.55 201.5 15.9 199.9 15.9 199.0 15.85 198.25 19.55 197.2 M76.6 181.05 L54.9 188.55 Q31.85 196.6 23.55 198.75 22.0 199.1 22.05 199.4 22.05 199.6 23.4 200.05 41.0 205.6 62.05 207.35 81.55 208.95 89.1 206.45 93.95 204.85 98.2 201.75 102.4 198.7 103.8 195.85 104.95 193.55 104.55 192.3 103.35 188.9 91.2 184.65 80.05 180.8 76.6 181.05"
        />
        <path
          fill="#0d131a"
          d="M60.45 25.8 Q61.4 24.6 61.8 24.6 62.25 24.6 63.1 25.85 68.2 33.05 69.75 38.7 69.0 42.65 68.85 40.85 68.75 39.35 65.55 33.4 62.3 27.3 61.65 27.85 58.8 30.2 56.2 38.2 53.4 46.75 53.8 53.6 53.9 56.1 54.6 59.0 L52.85 55.7 Q51.0 48.1 53.25 39.85 55.35 32.2 60.45 25.8"
        />
        <path
          fill="#0d131a"
          d="M118.65 1.75 Q118.85 4.15 118.4 11.1 117.9 19.0 117.05 19.65 L114.9 21.7 Q115.3 21.3 115.75 14.1 116.15 6.8 115.9 4.05 115.85 3.35 115.6 3.25 97.45 11.8 90.35 25.75 89.75 24.25 89.7 23.5 93.45 16.85 99.65 11.0 106.8 4.3 115.2 0.75 117.45 -0.15 118.0 0.0 118.55 0.2 118.65 1.75"
        />
        <path
          fill="#0d131a"
          d="M207.1 30.95 Q209.5 31.15 209.75 31.7 210.05 32.35 208.7 34.7 203.7 43.55 195.65 51.2 188.8 57.75 182.35 61.1 L179.25 61.5 Q187.4 56.0 197.7 44.55 206.95 34.2 206.4 33.4 L201.9 33.1 190.45 33.95 Q171.8 36.4 155.6 44.3 L157.45 41.55 Q181.6 29.1 207.1 30.95"
        />
        <path
          fill="#0d131a"
          d="M163.4 8.25 Q166.2 7.45 166.9 8.2 167.7 9.05 167.55 13.35 167.3 21.65 162.2 33.5 156.8 46.0 150.1 52.45 L147.5 52.8 Q153.6 46.95 158.95 34.95 164.2 23.0 164.75 14.1 164.95 11.2 164.4 10.85 164.05 10.6 161.8 11.35 153.3 14.25 142.3 22.2 131.05 30.3 129.5 34.95 L129.25 32.6 Q131.05 27.2 141.65 19.45 152.6 11.5 163.4 8.25"
        />
        <path
          fill="#0d131a"
          d="M190.95 79.5 Q179.7 87.25 167.7 91.05 L163.25 90.75 Q173.95 87.35 189.25 77.35 203.2 68.2 208.8 61.9 L208.95 61.5 208.65 61.35 Q197.2 59.55 181.7 61.55 169.05 63.15 158.25 66.5 L159.8 63.8 Q170.3 60.1 182.8 58.95 196.3 57.65 209.7 59.65 211.95 60.0 212.3 60.5 212.6 61.0 211.4 62.15 200.6 72.9 190.95 79.5"
        />
        <path
          fill="#0d131a"
          d="M186.65 97.1 Q178.2 94.1 169.05 92.85 141.65 89.05 128.85 103.4 L128.65 101.1 Q137.1 92.75 150.4 90.35 170.2 86.8 194.8 98.6 196.7 99.55 196.75 100.2 196.75 101.0 194.65 103.45 188.2 111.2 176.9 117.8 157.3 129.3 137.3 125.85 135.3 124.5 133.05 124.1 L129.15 124.0 124.95 124.15 125.75 120.55 Q149.6 129.7 173.75 116.7 181.65 112.45 188.25 106.5 193.45 101.85 193.75 100.6 194.0 99.7 186.65 97.1"
        />
        <path
          fill="#0d131a"
          d="M33.3 39.3 Q33.6 37.7 34.3 37.5 34.75 37.4 36.15 38.1 42.45 41.3 46.45 44.9 55.25 52.9 58.6 65.1 L57.55 67.2 Q54.8 57.05 47.2 49.2 43.45 45.4 36.85 40.95 35.9 40.35 35.65 40.4 35.45 40.5 35.35 41.3 35.2 42.25 35.0 45.55 L34.8 51.7 Q34.8 64.65 38.9 73.2 43.05 81.85 50.9 85.0 L50.2 86.6 Q40.1 82.55 35.15 68.2 30.25 54.15 33.3 39.3"
        />
        <path
          fill="#0d131a"
          d="M46.9 96.4 Q46.75 94.05 48.8 88.8 L51.45 82.6 Q52.05 81.15 52.35 81.55 52.65 82.0 52.1 83.8 L50.5 89.35 Q49.05 93.9 48.95 95.8 48.8 98.9 50.8 101.45 49.15 105.0 49.35 104.05 48.35 102.65 47.6 100.2 47.0 98.05 46.9 96.4"
        />
        <path
          fill="#0d131a"
          d="M128.75 14.45 L130.0 31.25 Q131.1 47.65 131.45 58.8 L129.4 60.3 Q128.7 42.2 126.0 15.6 125.9 14.15 124.95 14.75 118.85 18.95 108.3 30.0 98.35 40.45 94.0 46.7 92.85 48.4 92.3 48.4 91.75 48.4 92.5 46.5 88.3 21.3 87.7 19.7 87.5 19.15 86.95 19.4 82.05 22.25 73.95 34.5 62.9 51.25 57.05 72.3 56.35 74.65 55.65 74.6 54.9 74.55 55.45 72.05 57.95 60.6 65.15 45.75 75.15 25.1 86.95 16.55 88.55 15.4 89.2 15.65 89.8 15.85 90.05 17.55 L91.95 29.6 94.0 43.75 Q99.85 35.7 106.85 28.2 115.7 18.75 124.8 12.0 127.15 10.25 127.8 10.6 128.45 11.0 128.75 14.45"
        />
        <path
          fill="#0d131a"
          d="M129.0 88.6 L130.15 88.55 131.15 88.35 Q130.65 103.8 129.45 112.1 127.7 124.35 123.85 127.85 121.1 130.4 115.6 132.9 L106.0 136.7 99.4 139.35 Q96.0 140.8 94.8 141.9 L89.2 146.85 Q82.6 151.85 77.65 151.95 72.15 152.1 68.85 150.2 65.8 148.45 61.75 143.1 60.3 141.15 59.45 138.45 58.9 136.55 58.25 132.75 L56.75 126.2 54.8 119.75 Q53.65 118.8 55.6 120.3 L58.2 122.5 Q59.2 125.65 60.25 132.4 L61.35 138.05 Q62.15 140.9 63.4 142.45 67.55 147.55 70.65 148.95 72.7 149.85 77.2 149.85 81.65 149.85 88.25 145.1 L93.95 140.35 Q95.35 139.0 98.55 137.55 100.55 136.6 105.25 134.8 L114.05 131.35 Q118.85 129.2 121.4 126.85 127.4 121.3 129.0 88.6"
        />
        <path
          fill="#0d131a"
          d="M52.25 101.85 Q55.1 103.35 58.3 109.05 62.4 116.2 63.0 124.45 63.05 125.6 62.7 125.75 62.25 125.95 61.5 124.5 56.75 124.4 52.7 119.2 47.55 112.55 49.1 101.95 L49.6 101.3 Q50.45 100.9 52.25 101.85 M51.25 103.3 Q51.05 103.15 50.85 103.65 50.55 104.4 50.55 106.25 50.55 115.45 55.65 120.15 57.35 121.75 59.25 122.45 L61.15 122.6 Q60.8 118.5 59.0 114.15 56.35 107.8 51.25 103.3"
        />
        <path
          fill="#0d131a"
          d="M112.5 98.05 L112.35 94.3 Q101.25 97.8 95.6 106.35 91.35 112.8 91.35 119.35 L91.5 120.95 Q100.85 122.45 106.15 117.75 112.5 111.95 112.5 98.05 M112.95 92.25 Q116.25 91.3 116.55 91.8 116.8 92.35 114.1 93.9 115.4 111.7 107.3 119.05 104.25 121.8 100.45 122.7 96.55 123.6 91.3 122.7 90.8 124.0 90.4 123.85 89.95 123.7 89.8 121.5 89.15 111.85 93.75 104.75 99.55 95.8 112.95 92.25"
        />
        <path
          fill="#0d131a"
          d="M82.95 51.05 Q86.7 58.9 89.0 68.6 91.45 79.15 90.9 86.95 90.65 90.45 87.6 95.05 84.9 99.1 80.75 102.95 79.05 104.55 78.9 104.0 78.75 103.4 80.0 102.1 88.75 92.15 88.5 85.2 88.0 70.55 81.85 53.95 81.1 51.95 80.65 51.9 80.2 51.85 78.75 53.55 72.55 60.7 68.6 69.95 64.85 78.8 64.85 85.6 64.85 89.5 66.4 95.15 67.55 99.25 68.75 102.0 69.5 103.7 68.7 103.2 67.85 102.65 66.7 100.85 65.25 98.5 63.85 94.05 62.5 89.75 62.3 86.9 61.85 78.85 65.9 69.75 70.25 60.0 79.1 50.45 80.75 48.7 81.35 48.8 81.95 48.95 82.95 51.05"
        />
        <path
          fill="#0d131a"
          d="M167.6 50.2 Q169.2 50.35 169.3 50.85 169.4 51.25 168.5 53.3 162.6 66.4 151.15 76.7 138.1 88.4 124.05 90.1 121.55 90.4 121.35 89.75 121.15 89.15 123.55 88.8 135.15 87.25 146.5 76.95 155.5 68.75 165.1 54.2 166.4 52.15 165.1 52.05 143.7 51.55 130.15 61.8 122.1 67.95 115.15 80.35 114.35 81.75 114.15 81.25 113.9 80.75 114.35 79.35 118.65 67.0 129.6 59.05 144.6 48.1 167.6 50.2"
        />
      </g>
    </svg>
  );
};

export default Sandslash;
